export const APP_VERSION_REGEX = /^\d+(\.\d+){2,3}$/;
export const APP_VERSION_CONTAINER_NAME_MAX_LENGTH = 255;
export const APP_NAME_MAX_LENGTH = 100;
export const APP_DESCRIPTION_MAX_LENGTH = 50;
